exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SelectContentsModal {\n  padding: 1rem;\n}\n.SelectContentsModal .ResponsiveGrid {\n  align-items: flex-start;\n}\n.SelectContentsModal .ContentCard {\n  border-radius: 1rem;\n}\n.SelectContentsModal .ContentCard,\n.SelectContentsModal .ContentCard .CoverImage {\n  transition: all 0.2s;\n}\n.SelectContentsModal .ContentCard.\\--selected {\n  border: 4px solid #a05dcd;\n}\n.SelectContentsModal .ContentCard.\\--selected .CoverImage {\n  border-radius: 0.75rem;\n}\n@media (hover: hover) {\n.SelectContentsModal .ResponsiveGrid button:hover .ContentCard:not(.\\--selected) {\n    box-shadow: 0 0 0 4px #e4d2f1;\n}\n}\n", ""]);

// exports
